import { useMemo } from "react"
import { useQuery } from "@rocicorp/zero/react"

import { queries } from "@productlane/zero/queries"

import type { RoadmapTeam } from "./roadmap-team-groups"
import { useSelectedTeamIds } from "@/lib/use-team-filter"
import { groupTeamsByName } from "./roadmap-team-groups"

export function useRoadmapTeams(): RoadmapTeam[] {
	const [projects] = useQuery(queries.projects())
	const selectedTeamIds = useSelectedTeamIds()

	return useMemo(() => {
		const map = new Map<string, string>()
		for (const project of projects) {
			const ids = project.linearTeamIds ?? []
			const names = project.linearTeamNames ?? []
			for (let i = 0; i < ids.length; i++) {
				const id = ids[i]
				const name = names[i]
				if (!id || !name || map.has(id)) continue
				map.set(id, name)
			}
		}
		const teams = Array.from(map.entries())
			.filter(
				([id]) => selectedTeamIds.length === 0 || selectedTeamIds.includes(id),
			)
			.map(([id, name]) => ({ id, name }))
		return groupTeamsByName(teams)
	}, [projects, selectedTeamIds])
}
